import { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import ProtectedRoute from "../Components/Pages/ProtectedRoute";

import "../scss/app.scss";

import { CalculatorProvider } from "../Context/CalculatorContext";

import {
  STEP_ONE,
  STEP_TWO,
  STEP_THREE,
  STEP_FOUR,
  STEP_FIVE,
  STEP_SIX,
  STEP_SEVEN,
  STEP_EIGHT,
  STEP_NINE,
  RESULTS_PAGE,
  SIMULATION_PAGE,
} from "../Constants/RouteConstants";

import ScrollToTop from "../Components/Content/ScrollToTop";
import LayoutContainer from "./LayoutContainer";
import StepOnePage from "../Components/Pages/StepOnePage";
import StepTwoPage from "../Components/Pages/StepTwoPage";
import StepThreePage from "../Components/Pages/StepThreePage";
import StepFourPage from "../Components/Pages/StepFourPage";
import StepFivePage from "../Components/Pages/StepFivePage";
import StepSixPage from "../Components/Pages/StepSixPage";
import StepSevenPage from "../Components/Pages/StepSevenPage";
import StepEightPage from "../Components/Pages/StepEightPage";
import StepNinePage from "../Components/Pages/StepNinePage";
import ResultsPage from "../Components/Pages/ResultsPage";
import SimulationPage from "../Components/Pages/SimulationPage";
import PageMissing from "../Components/Debug/PageMissing";

/* eslint-disable react/jsx-props-no-spreading */
function RootContainer() {
  return (
    <Suspense fallback={null}>
      <BrowserRouter>
        <CalculatorProvider>
          <ScrollToTop />
          <LayoutContainer>
            <main id="page-content" className="bp-page-content main-section">
              <Routes>
                <Route path={STEP_ONE} element={<StepOnePage />} />

                <Route
                  path={STEP_TWO}
                  element={
                    <ProtectedRoute
                      redirectTarget={STEP_ONE}
                      conditionVariableName="forecastStartYear"
                    >
                      <StepTwoPage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path={STEP_THREE}
                  element={
                    <ProtectedRoute redirectTarget={STEP_TWO} conditionVariableName="energySource">
                      <StepThreePage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path={STEP_FOUR}
                  element={
                    <ProtectedRoute
                      redirectTarget={STEP_THREE}
                      conditionVariableName="isEmissionKnown"
                    >
                      <StepFourPage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path={STEP_FIVE}
                  element={
                    <ProtectedRoute
                      redirectTarget={STEP_FOUR}
                      conditionVariableName={["customEmission", "fuelConsumptionAmount"]}
                    >
                      <StepFivePage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path={STEP_SIX}
                  element={
                    <ProtectedRoute redirectTarget={STEP_FIVE} conditionVariableName="livingSpace">
                      <StepSixPage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path={STEP_SEVEN}
                  element={
                    <ProtectedRoute
                      redirectTarget={STEP_SIX}
                      conditionVariableName="isCommercialProperty"
                    >
                      <StepSevenPage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path={STEP_EIGHT}
                  element={
                    <ProtectedRoute
                      redirectTarget={STEP_SEVEN}
                      conditionVariableName="isEnergyImprovementPossible"
                    >
                      <StepEightPage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path={STEP_NINE}
                  element={
                    <ProtectedRoute redirectTarget={STEP_EIGHT} conditionVariableName="">
                      <StepNinePage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path={RESULTS_PAGE}
                  element={
                    <ProtectedRoute redirectTarget={STEP_NINE} conditionVariableName="">
                      <ResultsPage />
                    </ProtectedRoute>
                  }
                />

                {/* <Route
                  path={RESULTS_PAGE}
                  element={
                    <ProtectedRoute
                      redirectTarget={STEP_SIX}
                      conditionVariableName="isSupplyImprovementPossible"
                    >
                      <ResultsPage />
                    </ProtectedRoute>
                  }
                /> */}

                {/* <Route path={SIMULATION_PAGE} element={<SimulationPage />} /> */}

                <Route
                  path={SIMULATION_PAGE}
                  element={
                    <ProtectedRoute
                      redirectTarget={STEP_SIX}
                      conditionVariableName="isSupplyImprovementPossible"
                    >
                      <SimulationPage />
                    </ProtectedRoute>
                  }
                />

                <Route path="*" element={<PageMissing />} />
              </Routes>
            </main>
          </LayoutContainer>
        </CalculatorProvider>
      </BrowserRouter>
    </Suspense>
  );
}

export default RootContainer;
